/**
 * bármire ráfűzve kattintás után leszedi a gyerekelemeken lévő linkekről a href attribútumot
 * @author sarkiroka on 2016.07.11.
 */
export default function (app) {
	app.directive('noa', function () {
		return {
			link: function (scope, element) {
				$(element).click(function () {
					$(this).find('a').removeAttr('href');
				});
			}
		};
	});
};
